import Address from "components/Address";
import { AddressType } from "data/types";
import { FC, useState, useEffect } from "react";
import CommonLayout from "./CommonLayout";
import FormItem from "./FormItem";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import Modal from "shared/Modal";
import { useHistory } from "react-router";
import { addListing2 } from "actions/addListingActions";
import Radio from "shared/Radio";
import { addAddress } from "actions/addressActions";
// import Input from "shared/Input/Input";
// import { IInput } from "types/interfaces";
// import { XIcon, PlusIcon } from "@heroicons/react/outline";
// import formatRupiah from "utils/toRupiah";

export interface PageAddListing2Props {}

interface ILocation {
  name: string;
  price: number;
}

const PageAddListing2: FC<PageAddListing2Props> = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { addresses } = useSelector((state: RootState) => state.addressList);
  const { product } = useSelector((state: RootState) => state.productUpload);

  const [open, setOpen] = useState<boolean>(false);
  const [data, setData] = useState<AddressType>(product.addresses);
  const [error, setError] = useState<{ first: string; second: string }>({
    first: "",
    second: "",
  });
  // const [locationName, setLocationName] = useState<IInput>({
  //   value: "",
  //   warning: "",
  // });
  // const [locationPrice, setLocationPrice] = useState<IInput>({
  //   value: "0",
  //   warning: "",
  // });
  const [locations, setLocations] = useState<ILocation[]>([]);

  const handleAddAddress = (e: AddressType) => {
    dispatch(addAddress(e));
    setOpen(!open);
  };

  const handleOpen = () => {
    setOpen(!open);
  };

  const handleSelect = (id: string): void => {
    if (addresses) {
      const theOne = addresses.find((ad: AddressType) => ad._id === id);
      if (theOne) setData(theOne);
    }
  };

  // const handleAddLocation = (e: any) => {
  //   if (!locationName.value) {
  //     return setLocationName({
  //       ...locationName,
  //       warning: "Masukkan nama alamat",
  //     });
  //   }

  //   if (locations.length) {
  //     setLocations((previous) => [
  //       ...previous,
  //       {
  //         name: locationName.value,
  //         price: parseInt(locationPrice.value || "0"),
  //       },
  //     ]);
  //   } else {
  //     setLocations([
  //       {
  //         name: locationName.value,
  //         price: parseInt(locationPrice.value || "0"),
  //       },
  //     ]);
  //   }

  //   setLocationName({ value: "", warning: "" });
  //   setLocationPrice({ value: "0", warning: "" });

  //   e.preventDefault();
  // };

  const handleSubmit = () => {
    if (data) {
      setError({ ...error, first: "" });
    }
    // if (!locations.length || !data) {
    //   if (!locations.length) {
    //     setError({
    //       ...error,
    //       second: "Masukkan paling tidak satu alamat",
    //     });
    //   }
    if (!data) {
      return setError({ ...error, first: "Pilih salah satu alamat anda" });
    }
    //   return;
    // }

    dispatch(addListing2(data, locations));
    setError({ first: "", second: "" });
    history.push("/add-listing-6");
  };

  useEffect(() => {
    setLocations(product.locations);
    if (!!product.address._id) {
      setData(product.address);
    }

    if (!product.name) {
      history.push("/add-listing-1");
    }
  }, [product]);

  return (
    <CommonLayout
      index="02"
      nextHref="/add-listing-6"
      backtHref="/add-listing-1"
    >
      <>
        <h2 className="text-2xl font-semibold">Lokasi Barang</h2>
        <span className="block mt-2 text-neutral-500 dark:text-neutral-400">
          Lokasi tempat barang anda tersimpan. Bila tidak terdapat pilihan di
          bawah ini silahkan tambahkan alamat baru
        </span>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        {error.first && (
          <span className="text-sm text-red-500">{error.first}</span>
        )}
        {addresses.length > 0 ? (
          <FormItem>
            <Radio
              data={addresses}
              handleSelect={(e) => handleSelect(e)}
              oneSelected={data}
            />
          </FormItem>
        ) : (
          <span className="text-sm">
            Kelihatannya kamu tidak memiliki alamt terdaftar.{" "}
            <strong onClick={handleOpen}>Segera tambahkan alamatmu</strong>
          </span>
        )}

        <div>
          <ButtonSecondary onClick={handleOpen}>
            Tambah Alamat Baru
          </ButtonSecondary>
        </div>

        <Modal open={open} handleOpen={handleOpen} title="Tambahkan Alamat">
          <Address
            modify={false}
            handleClose={handleOpen}
            handleSubmit={handleAddAddress}
          />
        </Modal>
      </>
      {/* <div>
        <div>
          <h2 className="text-2xl font-semibold">Lokasi penyerahan barang</h2>
          <span className="block mt-2 text-neutral-500 dark:text-neutral-400">
            Tentukan lokasi tempat anda menyerahkan dan menerima barang kembali
            serta ongkos kirim yang sesuai (bila tidak ada ongkos kirim,
            tuliskan 0 pada kolom harga). Anda dapat menambahkan berapapun
            alamat yang anda inginkan.
          </span>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        {error.second && (
          <span className="text-sm text-red-500">
            Tambahkan paling tidak 1 titik temu
          </span>
        )}
        <div className="block sm:hidden">
          <div id="add-location" className="mb-3">
            <FormItem className="mb-3" label="Lokasi" required={true}>
              {" "}
              <Input
                value={locationName.value}
                placeholder="Bandara"
                onChange={(e) =>
                  setLocationName({ warning: "", value: e.target.value })
                }
              ></Input>
            </FormItem>
            <FormItem label="Ongkos Kirim" className="mb-3">
              {" "}
              <Input
                value={locationPrice.value}
                placeholder="20000"
                type="number"
                onChange={(e) =>
                  setLocationPrice({ warning: "", value: e.target.value })
                }
              ></Input>
            </FormItem>
            <button
              className="bg-primary-6000 py-1 px-4 rounded-md text-white"
              onClick={handleAddLocation}
            >
              Tambah Lokasi{" "}
            </button>
          </div>
          {locations.length > 0 &&
            locations.map((location, index) => {
              return (
                <div
                  className="flex justify-around border-2 border-primary-6000 rounded-lg p-3 mb-2"
                  key={index}
                >
                  <div className="w-full">
                    {" "}
                    <h1 className="font-bold">{location.name}</h1>
                    <p className=" ">
                      {location.price
                        ? "Rp " + formatRupiah(location.price)
                        : "free"}
                    </p>
                  </div>

                  <button
                    className="bg-red-400 p-3 rounded-md w-min"
                    onClick={() => {
                      const filteredLocations = locations.filter(
                        (value) => value.name !== location.name
                      );
                      setLocations(filteredLocations);
                    }}
                  >
                    <XIcon className="w-5 h-5" />
                  </button>
                </div>
              );
            })}
        </div>

        <div className="hidden sm:block w-max">
          <div className="grid grid-cols-3 gap-x-3 mb-2">
            <span className="pb-2 border-b-2">
              Nama Lokasi <span className="text-red-500">*</span>
            </span>
            <span className="pb-2 border-b-2">Ongkos Kirim</span>
          </div>

          {locations.length > 0 &&
            locations.map((location, index) => {
              return (
                <div className="grid grid-cols-3 gap-x-3 mb-2" key={index}>
                  <h1 className="font-bold h-11 py-3">{location.name}</h1>
                  <p className=" h-11 py-3">
                    {location.price
                      ? "Rp " + formatRupiah(location.price)
                      : "free"}
                  </p>
                  <button
                    className="bg-red-400 py-1 px-4 rounded-md w-min"
                    onClick={() => {
                      const filteredLocations = locations.filter(
                        (value) => value.name !== location.name
                      );
                      setLocations(filteredLocations);
                    }}
                  >
                    <XIcon className="w-3 h-3" />
                  </button>
                </div>
              );
            })}
          <div className="grid grid-cols-3 gap-x-3">
            <FormItem>
              {" "}
              <Input
                className="border-0 border-b-2 rounded-none"
                value={locationName.value}
                placeholder="Bandara"
                onChange={(e) =>
                  setLocationName({ warning: "", value: e.target.value })
                }
              ></Input>
            </FormItem>
            <FormItem>
              {" "}
              <Input
                className="border-0 border-b-2 rounded-none"
                value={locationPrice.value}
                placeholder="20000"
                type="number"
                onChange={(e) =>
                  setLocationPrice({ warning: "", value: e.target.value })
                }
              ></Input>
            </FormItem>
            <button
              className="bg-primary-6000 py-1 px-4 rounded-md w-min"
              onClick={handleAddLocation}
            >
              <PlusIcon className="w-3 h-3" />
            </button>
          </div>
          <div className="grid grid-cols-3 gap-x-3">
            <span className="text-sm text-red-600">{locationName.warning}</span>
            <span className="text-sm text-red-600">
              {locationPrice.warning}
            </span>
          </div>
        </div>
        <div>
          <ButtonSecondary onClick={handleOpen}>
            Tambah Alamat Baru
          </ButtonSecondary>
        </div> 

        
      </div> */}
      <div className="flex justify-end space-x-5">
        <ButtonSecondary href="/add-listing-1">Kembali</ButtonSecondary>
        <ButtonPrimary type="submit" onClick={handleSubmit}>
          {"Selanjutnya"}
        </ButtonPrimary>
      </div>
    </CommonLayout>
  );
};

export default PageAddListing2;

/**
 * import Address from "components/Address";
import { AddressType } from "data/types";
import { FC, useState, useEffect } from "react";
import CommonLayout from "./CommonLayout";
import FormItem from "./FormItem";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import Modal from "shared/Modal";
import { useHistory } from "react-router";
import { addListing2 } from "actions/addListingActions";
import Radio from "shared/Radio";
import { addAddress } from "actions/addressActions";

export interface PageAddListing2Props {}

const PageAddListing2: FC<PageAddListing2Props> = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { product } = useSelector((state: RootState) => state.productUpload);
  const { addresses } = useSelector((state: RootState) => state.addressList);

  const [open, setOpen] = useState<boolean>(false);
  const [data, setData] = useState<AddressType>(product.addresses);
  const [error, setError] = useState<Boolean>(false);

  const handleAddAddress = (e: AddressType) => {
    dispatch(addAddress(e));
    setOpen(!open);
  };

  const handleOpen = () => {
    setOpen(!open);
  };

  const handleSelect = (id: string): void => {
    if (addresses) {
      const theOne = addresses.find((ad: AddressType) => ad._id === id);
      if (theOne) setData(theOne);
    }
  };

  const handleSubmit = () => {
    if (!data) return setError(true);
    if (data._id) {
      dispatch(addListing2(data));
      setError(false);
      history.push("/add-listing-6");
    } else {
      setError(true);
    }
  };

  useEffect(() => {
    if (!!product.address._id) {
      setData(product.address);
    }

    if (!product.name) {
      history.push("/add-listing-1");
    }
  }, [product]);

  return (
    <CommonLayout
      index="02"
      nextHref="/add-listing-6"
      backtHref="/add-listing-1"
    >
      <>
        <h2 className="text-2xl font-semibold">Lokasi Penyewaan</h2>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        {error && (
          <span className="text-sm text-red-500">Pilih alamat yang dituju</span>
        )}
        <FormItem label="Pilih Alamat">
          <Radio
            data={addresses && addresses}
            handleSelect={(e) => handleSelect(e)}
            oneSelected={data}
          />
        </FormItem>
        <div>
          <ButtonSecondary onClick={handleOpen}>
            Tambah Alamat Baru
          </ButtonSecondary>
        </div>

        <Modal open={open} handleOpen={handleOpen} title="Tambahkan Alamat">
          <Address
            modify={false}
            handleClose={handleOpen}
            handleSubmit={handleAddAddress}
          />
        </Modal>
        <div className="flex justify-end space-x-5">
          <ButtonSecondary href="/add-listing-1">Kembali</ButtonSecondary>
          <ButtonPrimary type="submit" onClick={handleSubmit}>
            {"Selanjutnya"}
          </ButtonPrimary>
        </div>
      </>
    </CommonLayout>
  );
};

export default PageAddListing2;

 */
